<template>
    <el-cascader
      v-model="companyIdArr"
      :options="companyTreeOption"
      collapse-tags
      clearable
      :props="props"
      :show-all-levels="false"
      :placeholder="$t('BondOrUpdateDevice.OwnedCompany')"
      @change="searchChange"
      filterable
      :filter-method="filterHandle"
    />
</template>

<script>
import { mapState } from 'vuex'

export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      props: { multiple: true, value: 'id', label: 'companyName', children: 'childList' },
      companyIdArr: [],
      timer: null,
      num: 0
    }
  },
  computed: {
    ...mapState(['companyTreeOption'])
  },
  watch: {
    
    value(val) { // 父组件传来的值[id] 如：[78]
      if (val.length) {
        if (this.companyTreeOption.length) {
          this.companyIdArr = []
          val.forEach(v => {
            this.companyFn(v, this.companyTreeOption)
          })
        } else {
          this.timer = setInterval(() => {
            this.num++
            console.log(this.num, this.companyTreeOption)
            if (this.num >= 10 || this.companyTreeOption.length)clearInterval(this.timer)
            this.companyIdArr = []
            val.forEach(v => {
              this.companyFn(v, this.companyTreeOption)
            })
          }, 500)
        }
      } else {
        this.companyIdArr = []
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  mounted() {
    this.initData()
  },

  methods: {
    filterHandle (node, keyword) {
      const pattern = new RegExp(keyword.split('').join('.*'), 'i');
      return pattern.test(node.label + node.value);
    },
    initData() {
      if (this.value && typeof this.value === 'Array') {
        this.value.forEach(v => {
          this.companyIdArr.push([v])
        })
      }
    },
    searchChange(val) {
      const arr = []
      // console.log('**********this.companyIdArr,val',val,this.companyIdArr)
      this.companyIdArr.forEach(v => {
        var obj = v[v.length - 1]
        arr.push(obj)
      })
      this.$emit('change', arr)
    },
    companyFn(id, arr) { // 将父组件传来的值[id]，转换成绑定值[父级id，id]  如: [ 78 ] => [ 4, 27, 78 ]
      // console.log('**********id,arr',id,arr)
      var curIds = []
      arr.forEach(v => {
        if (id == v.id) {
          curIds = v.idx.split('-')
          // 当A公司有子级司时，无法选中A公司，所以将A公司也加入子级中，且将id改为'ID'+id·················start
          // 当A公司有子公司时，如果只选择A公司，不包含子公司，需要加入ID eg: [ "4", "6"]=> [ "4", "6", "ID6" ]
          if (typeof v.id === 'string' && v.id.indexOf('ID') > -1) {
            curIds.push(id)
          }
          // 当从设备分布页跳转时，路由中带了companyId,如果id公司下面有子公司，则需要在curIds中加入'ID'+id eg：["4","13"]=>[ "4","13","ID13"]
          if (v.childList)curIds.push('ID' + curIds[curIds.length - 1])
          // 当A公司有子级司时，无法选中A公司，所以将A公司也加入子级中，且将id改为'ID'+id·················end
          this.companyIdArr.push(curIds)
        } else if (v.childList && !curIds.length) {
          this.companyFn(id, v.childList)
        }
      })
    }
  }
}

</script>

<style lang="scss" scoped>
.searchCompanyWarp{
  display: inline-block;
  .el-cascader__tags .el-tag{
    max-width: 60%;
    margin: 2px 0 2px 6px;
    padding: 0 4px;
  }
  .el-cascader__search-input{
    margin: 2px 0 2px 5px;
  }
}
</style>
